import { useEffect, useRef } from 'react';

const FunkyGraphics = () => {
  return (
    <section className="relative py-16 overflow-hidden bg-[#1a1aff]" data-testid="funky-graphics">
      {/* Main pattern container */}
      <div className="relative max-w-7xl mx-auto px-4">
        
        {/* Top row of stickers */}
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 mb-6">
          <div className="font-['Anton'] text-3xl md:text-4xl bg-[#fe5e54] text-black px-4 py-2 border-4 border-black shadow-[4px_4px_0px_0px_#000] transform -rotate-3">
            BOLD
          </div>
          <div className="w-12 h-12 bg-[#fcd200] rounded-full border-4 border-black" />
          <div className="font-['Anton'] text-3xl md:text-4xl bg-[#00c9b0] text-black px-4 py-2 border-4 border-black shadow-[4px_4px_0px_0px_#000] transform rotate-2">
            NEON
          </div>
          <div className="text-[#fcd200] text-5xl">★</div>
          <div className="font-['Anton'] text-4xl md:text-5xl bg-[#fcd200] text-black px-4 py-2 border-4 border-black shadow-[4px_4px_0px_0px_#000] transform -rotate-2">
            CNC
          </div>
          <div className="w-10 h-10 bg-[#fe5e54] rotate-45 border-4 border-black" />
          <div className="font-['Anton'] text-3xl md:text-4xl bg-[#36008d] text-white px-4 py-2 border-4 border-black shadow-[4px_4px_0px_0px_#000] transform rotate-3">
            LED
          </div>
        </div>

        {/* Middle row */}
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 mb-6">
          <div className="font-['Anton'] text-2xl md:text-3xl bg-black text-white px-4 py-2 border-4 border-[#00c9b0] transform rotate-1">
            → LOOK HERE
          </div>
          <div className="w-16 h-16 border-6 border-[#00c9b0] rounded-full" />
          <div className="font-['Anton'] text-4xl md:text-5xl bg-[#fe5e54] text-black px-4 py-2 border-4 border-black shadow-[4px_4px_0px_0px_#000] transform -rotate-1">
            SIGNS
          </div>
          <div className="w-14 h-14 bg-[#fcd200] rounded-full border-4 border-black flex items-center justify-center">
            <span className="text-2xl">:)</span>
          </div>
          <div className="font-['Anton'] text-3xl md:text-4xl bg-[#00c9b0] text-black px-4 py-2 border-4 border-black shadow-[4px_4px_0px_0px_#000] transform rotate-2">
            CUSTOM
          </div>
          <div className="text-[#fe5e54] text-5xl">✦</div>
        </div>

        {/* Bottom row */}
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6">
          <div className="font-['Anton'] text-3xl md:text-4xl bg-[#fcd200] text-black px-4 py-2 border-4 border-black shadow-[4px_4px_0px_0px_#000] transform rotate-2">
            GLOW
          </div>
          <div className="w-10 h-10 bg-[#36008d] border-4 border-black" />
          <div className="font-['Anton'] text-3xl md:text-4xl bg-[#36008d] text-white px-4 py-2 border-4 border-black shadow-[4px_4px_0px_0px_#000] transform -rotate-3">
            LASER
          </div>
          <div className="font-['Anton'] text-4xl bg-[#fe5e54] text-white p-3 border-4 border-black transform rotate-3">
            #1
          </div>
          <div className="font-['Anton'] text-2xl md:text-3xl bg-[#00c9b0] text-black px-4 py-2 border-4 border-black shadow-[4px_4px_0px_0px_#000] transform -rotate-1">
            ACRYLIC
          </div>
          <div className="text-[#fcd200] text-5xl">★</div>
          <div className="font-['Anton'] text-3xl md:text-4xl bg-[#fe5e54] text-black px-4 py-2 border-4 border-black shadow-[4px_4px_0px_0px_#000] transform rotate-1">
            WOW
          </div>
        </div>

      </div>

      {/* Bottom text strip */}
      <div className="mt-12 bg-black py-4 border-y-4 border-[#00c9b0]">
        <div className="flex justify-center items-center gap-8 flex-wrap px-4">
          <span className="font-['Anton'] text-3xl md:text-4xl text-[#fe5e54]">SIGNS</span>
          <span className="text-[#fcd200] text-3xl">★</span>
          <span className="font-['Anton'] text-3xl md:text-4xl text-[#00c9b0]">MADE</span>
          <span className="text-[#fe5e54] text-3xl">★</span>
          <span className="font-['Anton'] text-3xl md:text-4xl text-[#fcd200]">OBVIOUSLY</span>
        </div>
      </div>
    </section>
  );
};

export default FunkyGraphics;
